import BS_Glyphicons from "./components/BS_Glyphicons.jsx";
import FA4_Brand from "./components/FA4_Brand.jsx";
import FA4_Chart from "./components/FA4_Chart.jsx";
import FA4_Currency from "./components/FA4_Currency.jsx";
import FA4_Directional from "./components/FA4_Directional.jsx";
import FA4_File_Type from "./components/FA4_File_Type.jsx";
import FA4_Form from "./components/FA4_Form.jsx";
import FA4_Gender from "./components/FA4_Gender.jsx";
import FA4_Hand from "./components/FA4_Hand.jsx";
import FA4_Intro from "./components/FA4_Intro.jsx";
import FA4_Medical from "./components/FA4_Medical.jsx";
import FA4_Payment from "./components/FA4_Payment.jsx";
import FA4_Spinner from "./components/FA4_Spinner.jsx";
import FA4_Text from "./components/FA4_Text.jsx";
import FA4_Transportation from "./components/FA4_Transportation.jsx";
import FA4_Video from "./components/FA4_Video.jsx";
import FA4_Web_Application from "./components/FA4_Web_Application.jsx";
import FA5_Accessibility from "./components/FA5_Accessibility.jsx";
import FA5_Alert from "./components/FA5_Alert.jsx";
import FA5_Animals from "./components/FA5_Animals.jsx";
import FA5_Arrows from "./components/FA5_Arrows.jsx";
import FA5_Audio_Video from "./components/FA5_Audio_Video.jsx";
import FA5_Automotive from "./components/FA5_Automotive.jsx";
import FA5_Autumn from "./components/FA5_Autumn.jsx";
import FA5_Beverage from "./components/FA5_Beverage.jsx";
import FA5_Brands from "./components/FA5_Brands.jsx";
import FA5_Buildings from "./components/FA5_Buildings.jsx";
import FA5_Business from "./components/FA5_Business.jsx";
import FA5_Camping from "./components/FA5_Camping.jsx";
import FA5_Charity from "./components/FA5_Charity.jsx";
import FA5_Chat from "./components/FA5_Chat.jsx";
import FA5_Chess from "./components/FA5_Chess.jsx";
import FA5_Childhood from "./components/FA5_Childhood.jsx";
import FA5_Clothing from "./components/FA5_Clothing.jsx";
import FA5_Code from "./components/FA5_Code.jsx";
import FA5_Communication from "./components/FA5_Communication.jsx";
import FA5_Computers from "./components/FA5_Computers.jsx";
import FA5_Construction from "./components/FA5_Construction.jsx";
import FA5_Currency from "./components/FA5_Currency.jsx";
import FA5_Date_Time from "./components/FA5_Date_Time.jsx";
import FA5_Design from "./components/FA5_Design.jsx";
import FA5_Editors from "./components/FA5_Editors.jsx";
import FA5_Education from "./components/FA5_Education.jsx";
import FA5_Emoji from "./components/FA5_Emoji.jsx";
import FA5_Energy from "./components/FA5_Energy.jsx";
import FA5_Files from "./components/FA5_Files.jsx";
import FA5_Finance from "./components/FA5_Finance.jsx";
import FA5_Fitness from "./components/FA5_Fitness.jsx";
import FA5_Food from "./components/FA5_Food.jsx";
import FA5_Fruits_Vegetables from "./components/FA5_Fruits_Vegetables.jsx";
import FA5_Games from "./components/FA5_Games.jsx";
import FA5_Genders from "./components/FA5_Genders.jsx";
import FA5_Halloween from "./components/FA5_Halloween.jsx";
import FA5_Hands from "./components/FA5_Hands.jsx";
import FA5_Health from "./components/FA5_Health.jsx";
import FA5_Holiday from "./components/FA5_Holiday.jsx";
import FA5_Hotel from "./components/FA5_Hotel.jsx";
import FA5_Household from "./components/FA5_Household.jsx";
import FA5_Images from "./components/FA5_Images.jsx";
import FA5_Interfaces from "./components/FA5_Interfaces.jsx";
import FA5_Intro from "./components/FA5_Intro.jsx";
import FA5_Logistics from "./components/FA5_Logistics.jsx";
import FA5_Maps from "./components/FA5_Maps.jsx";
import FA5_Maritime from "./components/FA5_Maritime.jsx";
import FA5_Marketing from "./components/FA5_Marketing.jsx";
import FA5_Mathematics from "./components/FA5_Mathematics.jsx";
import FA5_Medical from "./components/FA5_Medical.jsx";
import FA5_Moving from "./components/FA5_Moving.jsx";
import FA5_Music from "./components/FA5_Music.jsx";
import FA5_Objects from "./components/FA5_Objects.jsx";
import FA5_Payment_Shopping from "./components/FA5_Payment_Shopping.jsx";
import FA5_Pharmacy from "./components/FA5_Pharmacy.jsx";
import FA5_Political from "./components/FA5_Political.jsx";
import FA5_Religion from "./components/FA5_Religion.jsx";
import FA5_Science from "./components/FA5_Science.jsx";
import FA5_Science_Fiction from "./components/FA5_Science_Fiction.jsx";
import FA5_Security from "./components/FA5_Security.jsx";
import FA5_Shapes from "./components/FA5_Shapes.jsx";
import FA5_Shopping from "./components/FA5_Shopping.jsx";
import FA5_Social from "./components/FA5_Social.jsx";
import FA5_Spinners from "./components/FA5_Spinners.jsx";
import FA5_Sports from "./components/FA5_Sports.jsx";
import FA5_Spring from "./components/FA5_Spring.jsx";
import FA5_Status from "./components/FA5_Status.jsx";
import FA5_Summer from "./components/FA5_Summer.jsx";
import FA5_Tabletop_Gaming from "./components/FA5_Tabletop_Gaming.jsx";
import FA5_Toggle from "./components/FA5_Toggle.jsx";
import FA5_Travel from "./components/FA5_Travel.jsx";
import FA5_Users_People from "./components/FA5_Users_People.jsx";
import FA5_Vehicles from "./components/FA5_Vehicles.jsx";
import FA5_Weather from "./components/FA5_Weather.jsx";
import FA5_Winter from "./components/FA5_Winter.jsx";
import FA5_Writing from "./components/FA5_Writing.jsx";
import Google_AV from "./components/Google_AV.jsx";
import Google_Action from "./components/Google_Action.jsx";
import Google_Alert from "./components/Google_Alert.jsx";
import Google_Communication from "./components/Google_Communication.jsx";
import Google_Content from "./components/Google_Content.jsx";
import Google_Device from "./components/Google_Device.jsx";
import Google_Editor from "./components/Google_Editor.jsx";
import Google_File from "./components/Google_File.jsx";
import Google_Hardware from "./components/Google_Hardware.jsx";
import Google_Image from "./components/Google_Image.jsx";
import Google_Intro from "./components/Google_Intro.jsx";
import Google_Maps from "./components/Google_Maps.jsx";
import Google_Navigation from "./components/Google_Navigation.jsx";
import Google_Notification from "./components/Google_Notification.jsx";
import Google_Places from "./components/Google_Places.jsx";
import Google_Social from "./components/Google_Social.jsx";
import Google_Toggle from "./components/Google_Toggle.jsx";
import Icons from "./components/Icons.jsx";
import Icons_Home from "./components/Icons_Home.jsx";
import Icons_Reference from "./components/Icons_Reference.jsx";

const iconsComponentsMap = {
  "<BS_Glyphicons />": BS_Glyphicons,
  "<FA4_Brand />": FA4_Brand,
  "<FA4_Chart />": FA4_Chart,
  "<FA4_Currency />": FA4_Currency,
  "<FA4_Directional />": FA4_Directional,
  "<FA4_File_Type />": FA4_File_Type,
  "<FA4_Form />": FA4_Form,
  "<FA4_Gender />": FA4_Gender,
  "<FA4_Hand />": FA4_Hand,
  "<FA4_Intro />": FA4_Intro,
  "<FA4_Medical />": FA4_Medical,
  "<FA4_Payment />": FA4_Payment,
  "<FA4_Spinner />": FA4_Spinner,
  "<FA4_Text />": FA4_Text,
  "<FA4_Transportation />": FA4_Transportation,
  "<FA4_Video />": FA4_Video,
  "<FA4_Web_Application />": FA4_Web_Application,
  "<FA5_Accessibility />": FA5_Accessibility,
  "<FA5_Alert />": FA5_Alert,
  "<FA5_Animals />": FA5_Animals,
  "<FA5_Arrows />": FA5_Arrows,
  "<FA5_Audio_Video />": FA5_Audio_Video,
  "<FA5_Automotive />": FA5_Automotive,
  "<FA5_Autumn />": FA5_Autumn,
  "<FA5_Beverage />": FA5_Beverage,
  "<FA5_Brands />": FA5_Brands,
  "<FA5_Buildings />": FA5_Buildings,
  "<FA5_Business />": FA5_Business,
  "<FA5_Camping />": FA5_Camping,
  "<FA5_Charity />": FA5_Charity,
  "<FA5_Chat />": FA5_Chat,
  "<FA5_Chess />": FA5_Chess,
  "<FA5_Childhood />": FA5_Childhood,
  "<FA5_Clothing />": FA5_Clothing,
  "<FA5_Code />": FA5_Code,
  "<FA5_Communication />": FA5_Communication,
  "<FA5_Computers />": FA5_Computers,
  "<FA5_Construction />": FA5_Construction,
  "<FA5_Currency />": FA5_Currency,
  "<FA5_Date_Time />": FA5_Date_Time,
  "<FA5_Design />": FA5_Design,
  "<FA5_Editors />": FA5_Editors,
  "<FA5_Education />": FA5_Education,
  "<FA5_Emoji />": FA5_Emoji,
  "<FA5_Energy />": FA5_Energy,
  "<FA5_Files />": FA5_Files,
  "<FA5_Finance />": FA5_Finance,
  "<FA5_Fitness />": FA5_Fitness,
  "<FA5_Food />": FA5_Food,
  "<FA5_Fruits_Vegetables />": FA5_Fruits_Vegetables,
  "<FA5_Games />": FA5_Games,
  "<FA5_Genders />": FA5_Genders,
  "<FA5_Halloween />": FA5_Halloween,
  "<FA5_Hands />": FA5_Hands,
  "<FA5_Health />": FA5_Health,
  "<FA5_Holiday />": FA5_Holiday,
  "<FA5_Hotel />": FA5_Hotel,
  "<FA5_Household />": FA5_Household,
  "<FA5_Images />": FA5_Images,
  "<FA5_Interfaces />": FA5_Interfaces,
  "<FA5_Intro />": FA5_Intro,
  "<FA5_Logistics />": FA5_Logistics,
  "<FA5_Maps />": FA5_Maps,
  "<FA5_Maritime />": FA5_Maritime,
  "<FA5_Marketing />": FA5_Marketing,
  "<FA5_Mathematics />": FA5_Mathematics,
  "<FA5_Medical />": FA5_Medical,
  "<FA5_Moving />": FA5_Moving,
  "<FA5_Music />": FA5_Music,
  "<FA5_Objects />": FA5_Objects,
  "<FA5_Payment_Shopping />": FA5_Payment_Shopping,
  "<FA5_Pharmacy />": FA5_Pharmacy,
  "<FA5_Political />": FA5_Political,
  "<FA5_Religion />": FA5_Religion,
  "<FA5_Science />": FA5_Science,
  "<FA5_Science_Fiction />": FA5_Science_Fiction,
  "<FA5_Security />": FA5_Security,
  "<FA5_Shapes />": FA5_Shapes,
  "<FA5_Shopping />": FA5_Shopping,
  "<FA5_Social />": FA5_Social,
  "<FA5_Spinners />": FA5_Spinners,
  "<FA5_Sports />": FA5_Sports,
  "<FA5_Spring />": FA5_Spring,
  "<FA5_Status />": FA5_Status,
  "<FA5_Summer />": FA5_Summer,
  "<FA5_Tabletop_Gaming />": FA5_Tabletop_Gaming,
  "<FA5_Toggle />": FA5_Toggle,
  "<FA5_Travel />": FA5_Travel,
  "<FA5_Users_People />": FA5_Users_People,
  "<FA5_Vehicles />": FA5_Vehicles,
  "<FA5_Weather />": FA5_Weather,
  "<FA5_Winter />": FA5_Winter,
  "<FA5_Writing />": FA5_Writing,
  "<Google_AV />": Google_AV,
  "<Google_Action />": Google_Action,
  "<Google_Alert />": Google_Alert,
  "<Google_Communication />": Google_Communication,
  "<Google_Content />": Google_Content,
  "<Google_Device />": Google_Device,
  "<Google_Editor />": Google_Editor,
  "<Google_File />": Google_File,
  "<Google_Hardware />": Google_Hardware,
  "<Google_Image />": Google_Image,
  "<Google_Intro />": Google_Intro,
  "<Google_Maps />": Google_Maps,
  "<Google_Navigation />": Google_Navigation,
  "<Google_Notification />": Google_Notification,
  "<Google_Places />": Google_Places,
  "<Google_Social />": Google_Social,
  "<Google_Toggle />": Google_Toggle,
  "<Icons />": Icons,
  "<Icons_Home />": Icons_Home,
  "<Icons_Reference />": Icons_Reference,
};

export default iconsComponentsMap;
